<template>
  <div>
    <div
      id="selectTeacherDiv"
      v-for="(value, name) in canSecelectProducts"
      :key="name"
    >
      <div class="m-2 fw-bold">{{ name }}</div>
      <div
        class="row g-0 bg-warning p-2 align-items-center d-flex"
        v-for="item in value"
        :key="item.id"
      >
        <div class="col-1">
          <input
            type="radio"
            :name="name"
            @change="addToSelected(item.id, name)"
          />
        </div>
        <div class="col-8">
          <span class="ms-2">{{ item.child_product.name }}</span>
        </div>
        <div class="col-3">
          <span class="text-danger text-decoration-line-through fw-bold">
            {{ this.utils.monize(item.child_product.price) }}
          </span>
          <br />
          <span class="text-success fw-bold">
            {{ this.utils.monize(item.package_price) }}
            تومان
          </span>
        </div>
      </div>
    </div>

    <hr />
    <div
      class="row g-0 bg-light p-2 align-items-center d-flex"
      v-for="(item, index) in childProducts.others"
      :key="item.id"
    >
      <div class="col-1">{{ index + 1 }}</div>
      <div class="col-8">
        <span class="ms-2">{{ item.child_product.name }}</span>
      </div>
      <div class="col-3">
        <span class="text-danger text-decoration-line-through fw-bold">
          {{ this.utils.monize(item.child_product.price) }}
        </span>
        <br />
        <span class="text-success fw-bold">
          {{ this.utils.monize(item.package_price) }}
          تومان
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import utils from "@/libs/utils";
import ArefApi from "@/libs/api.js";

export default {
  props: {
    productId: {
      type: Number,
      required: true,
    },
  },
  emits: {
    setProductChildIds: {
      type: Function,
    },
  },
  data() {
    return {
      API_STORAGE_URL: process.env.VUE_APP_API_STORAGE_URL,
      childProducts: {},
      selectedProductChildIds: [],
      //selectedProductChildIds: this.childProducts.others.map((x) => x.id),
    };
  },
  created() {
    this.utils = new utils();
    this.arefApi = new ArefApi();
    this.getAdminChildProducts(this.productId);
  },
  methods: {
    addToSelected(productChildId, name) {
      this.removeRelatedIdsFromSelected(name);
      this.selectedProductChildIds.push(productChildId);
      //const target_copy = Object.assign([], this.selectedProductChildIds);
      //console.log(Object.values(this.selectedProductChildIds));
      this.$emit(
        "setProductChildIds",
        Object.values(this.selectedProductChildIds)
      );
    },
    removeRelatedIdsFromSelected(name) {
      const allRelatedIds = this.childProducts[name].map((x) => x.id);
      for (const i in this.selectedProductChildIds) {
        if (allRelatedIds.indexOf(this.selectedProductChildIds[i]) > -1) {
          delete this.selectedProductChildIds[i];
        }
      }
    },
    getAdminChildProducts(productId) {
      this.arefApi.getAdminChildProducts(productId).then((response) => {
        this.childProducts = response.data;
        this.selectedProductChildIds = this.childProducts.others.map(
          (x) => x.id
        );
        console.log("childProducts", this.childProducts);
        console.log("selectedProductChildIds", this.selectedProductChildIds);
      });
    },
  },
  computed: {
    canSecelectProducts() {
      let out = { ...this.childProducts };
      if (out.others) {
        delete out.others;
      }
      return out;
    },
  },
};
</script>